import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import APIEndpoints from '../../../../api/APIEndpoints';
import MasterPermissions from '../../../../api/MasterPermissions';
import { axiosInstance } from '../../../../../api/axios';
import {
  getViewEmployeeDetails,
  getViewEmploymentDetails,
  getViewContactInformation,
} from '../../../../utils/common';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { setMemberDetails, setMemberList } from 'src/redux/admin/memberModule';

const useProfile = (isApprovalFlow = false, isAffiliation = false) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [defaultTab, setDefaultTab] = useState('');
  const [viewUserProfile, setViewUserProfile] = useState(
    MasterPermissions.CheckPermission('View Self Profile Information'),
  );
  console.log(
    'MasterPermissions >>>>>>>>',
    MasterPermissions.getPermissionFramework(),
  );
  const [viewDependent, setViewDependent] = useState(
    MasterPermissions.CheckPermission('View Dependent Profile Information'),
  );
  const [viewHippaRights, setViewHippaRights] = useState(
    MasterPermissions.CheckPermission('View HIPAA Patient Rights Information'),
  );
  const [employeeData, setEmployeeData] = useState({});
  const [eobPreferences, setEobPreferences] = useState({});
  const [dependentsData, setDependentsData] = useState([]);
  const [residentialData, setResidentialData] = useState({});
  const [mailingData, setMailingData] = useState({});
  const [allowEmpViewMyInfo, setAllowEmpViewMyInfo] = useState();
  const [allowRespPartyViewMyInfo, setAllowRespPartyViewMyInfo] = useState();
  const [responsiblePartyInfo, setResponsiblePartyInfo] = useState([]);
  const [serverError, setServerError] = useState(false);
  const [serverErrorHipaa, setServerErrorHipaa] = useState(false);
  const [activeDependentId, setactiveDependentId] = useState('');
  const [isSummaryApiSettled, setIsSummaryApiSettled] = useState(false);
  const { selectedMember, memberDetails } = useSelector(
    (state) => state.memberModule,
  );
  console.log('selectedMember', selectedMember);
  const getDefaultTab = () => {
    return viewUserProfile
      ? setDefaultTab('user-profile')
      : viewDependent
      ? setDefaultTab('dependents')
      : viewHippaRights
      ? setDefaultTab('hippa-patient-right')
      : setDefaultTab('user-profile');
  };

  const setDependentsLoadedInfo = (data) => {
    return data.map((item) => ({
      ...item,
      dependentsInfoLoaded: false,
      dependentsAPIError: false,
    }));
  };

  const fetchEmployeeData = async () => {
    console.log('fetchEmployeeData out');
    try {
      console.log('fetchEmployeeData isAffiliation', isAffiliation);
      const params = `oid/${selectedMember.ID}/membertype/${selectedMember.mType}`;
      console.log('fetchEmployeeData params', params);
      const apiURl = isAffiliation
        ? APIEndpoints.getViewMemberinformationV2()
        : APIEndpoints.getViewMemberinformation();
      console.log('fetchEmployeeData apiURl', apiURl);
      const responseEmployeeData = await axiosInstance.get(apiURl + params);

      console.log('responseEmployeeData here', responseEmployeeData);

      if (selectedMember.mType === 'Employee') {
        setEmployeeData(
          responseEmployeeData?.data?.Response?.MemberInformation,
        );
        setResidentialData(
          responseEmployeeData?.data?.Response?.Memberresidentailaddress,
        );
        setMailingData(
          responseEmployeeData?.data?.Response?.Membermailingaddress,
        );
        setDependentsData(
          setDependentsLoadedInfo(
            responseEmployeeData?.data?.Response?.DependentsInfo,
          ),
        );
        const {
          MailPaperEOB,
          ReceiveMail,
          Email: EobPreferenceMail,
        } = responseEmployeeData.data.Response.MemberInformation;
        setEobPreferences({
          MailPaperEOB: MailPaperEOB,
          ReceiveMail: ReceiveMail,
          EobPreferenceMail: EobPreferenceMail,
        });
        setLoader(false);
      } else if (selectedMember.mType === 'Dependent') {
        setEmployeeData(
          responseEmployeeData?.data?.Response?.DependentsInformation,
        );
        setResidentialData(
          responseEmployeeData?.data?.Response?.Dependentresidentailaddress[0],
        );
        setMailingData(
          responseEmployeeData?.data?.Response?.Dependentmailingaddress[0],
        );
        setDependentsData([]);
        const {
          MailPaperEOB,
          ReceiveMail,
          Email: EobPreferenceMail,
        } = responseEmployeeData.data.Response.DependentsInformation;
        setEobPreferences({
          MailPaperEOB: MailPaperEOB,
          ReceiveMail: ReceiveMail,
          EobPreferenceMail: EobPreferenceMail,
        });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (e) {
      console.log('eror-----', e);
      setLoader(false);
      setServerError(true);
    }
  };

  const fetchDependentsData = async (DepSequenceNumber) => {
    try {
      const params = configureParams(DepSequenceNumber);
      const responseDependentsData = await axiosInstance.get(
        isAffiliation
          ? APIEndpoints.getViewMemberinformationV2() + params
          : APIEndpoints.getViewMemberinformation() + params,
      );
      const tempDependentsData = [...dependentsData].map((item) =>
        item.DepSequenceNumber === DepSequenceNumber
          ? {
              ...item,
              dependentsInfoLoaded: true,
              DependentsInformation: getViewEmployeeDetails(
                responseDependentsData?.data?.Response?.DependentsInformation,
                true,
              ),
              DependentResidentailAddress: getAddressLine(
                responseDependentsData?.data?.Response
                  ?.Dependentresidentailaddress[0],
              ),
              DependentMailingAddress: getAddressLine(
                responseDependentsData?.data?.Response
                  ?.Dependentmailingaddress[0] || undefined,
              ),
              DependentResidentailAddressZip: getAddressLineZip(
                responseDependentsData?.data?.Response
                  ?.Dependentresidentailaddress[0],
              ),
              DependentMailingAddressZip: getAddressLineZip(
                responseDependentsData?.data?.Response
                  ?.Dependentmailingaddress[0] || undefined,
              ),
              PhoneEmailInfo: getViewContactInformation(
                responseDependentsData?.data?.Response?.DependentsInformation,
                true,
              ),
            }
          : { ...item },
      );
      setDependentsData(tempDependentsData);
      //setEmployeeData(
      //responseDependentsData?.data?.Response?.DependentsInformation,
      //);
      setResidentialData(
        responseDependentsData?.data?.Response?.Dependentresidentailaddress[0],
      );
      setMailingData(
        responseDependentsData?.data?.Response?.Dependentmailingaddress[0],
      );
      const dependentId = params.split('/')[1];
      setactiveDependentId(dependentId);
    } catch (e) {
      const tempDependentsData = [...dependentsData].map((item) =>
        item.DepSequenceNumber === DepSequenceNumber
          ? { ...item, dependentsInfoLoaded: true, dependentsAPIError: true }
          : { ...item },
      );
      setDependentsData(tempDependentsData);
    }
  };

  const fetchHippaPatientRights = async () => {
    try {
      const params = `oid/${selectedMember.ID}/membertype/${selectedMember.mType}`;
      const responseData = await axiosInstance.get(
        APIEndpoints.getHippaPermissionsResources() + params,
      );
      setAllowEmpViewMyInfo(responseData?.data?.Response?.AllowEmpViewMyInfo);
      setAllowRespPartyViewMyInfo(
        responseData?.data?.Response?.AllowRespPartyViewMyInfo,
      );
      setResponsiblePartyInfo(
        convertDataToTableFormat(responseData?.data?.Response?.RespPartyInfo),
      );
    } catch (e) {
      setServerErrorHipaa(true);
    }
  };

  const convertDataToTableFormat = (data) => {
    return data.map((item) => ({
      responsibleParty: 'Yes',
      name: item.FirstName + ' ' + item.LastName,
      relationship: item.Relationship,
    }));
  };

  const getAddressLine = (address) => {
    return `${address?.Address1 ? address?.Address1 : ''} ${
      address?.Address2 ? address?.Address2 : ''
    } ${address?.Address3 ? address?.Address3 : ''} ${
      address?.County ? address?.County : ''
    } ${address?.City ? address?.City + ',' : ''} ${
      address?.State ? address?.State : ''
    }`;
  };

  const getAddressLineZip = (address) => {
    return `${address?.PostalCode ? address?.PostalCode : ''} ${
      address?.Country ? address?.Country : ''
    } `;
  };

  const configureParams = (DepSequenceNumber) => {
    const dependentsList = memberDetails?.Member?.DependentsInfo;
    const selectedDependent = dependentsList.filter(
      (item) => item.MemberSeqID === parseInt(DepSequenceNumber),
    )[0];
    return `oid/${selectedDependent.OID}/membertype/Dependent`;
  };

  const getMemberDetails = async () => {
    if (isSummaryApiSettled) return;
    const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
    try {
      const response = await axiosInstance.get(
        cacheBuster(
          APIEndpoints.getMemberSummaryResource() +
            'membertype/' +
            selectedMember.mType +
            '/oid/' +
            selectedMember.ID,
        ),
      );

      const memberSummaryDataResp = response.data;
      const memberSummary = memberSummaryDataResp?.Response?.Member;
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        setIsSummaryApiSettled(true);
        dispatch(setMemberDetails(memberSummaryDataResp?.Response));

        const MemberList = [];
        if (memberSummary?.DependentsInfo?.length == 0) {
          MemberList.push({
            name:
              memberSummary?.FirstName + ' (' + memberSummary?.LastName + ')',
            fullname: memberSummary?.FirstName + ' ' + memberSummary?.LastName,
            count: 0,
            coverageType:
              memberSummary?.LoggedInMemberType == 'Employee'
                ? 'Employee'
                : 'Dependent',
            OID: memberSummary?.OID,
          });
        } else {
          console.log('With Dependents');

          MemberList.push({
            name:
              memberSummary?.FirstName + ' (' + memberSummary?.LastName + ')',
            fullname: memberSummary?.FirstName + ' ' + memberSummary?.LastName,
            FirstName: memberSummary?.FirstName,
            count: 1,
            coverageType: 'Employee',
            OID: memberSummary?.OID,
          });
          let dependent;

          for (
            let iIndex = 0;
            iIndex < memberSummary.DependentsInfo?.length;
            iIndex++
          ) {
            dependent = memberSummary?.DependentsInfo[iIndex];
            MemberList.push({
              name:
                dependent?.FirstName +
                ' (' +
                dependent?.RelationshipToMember +
                ')',
              fullname: dependent?.FirstName + ' ' + dependent?.LastName,
              FirstName: memberSummary?.FirstName,
              count: iIndex + 1,
              coverageType: 'Dependent',
              OID: dependent?.OID,
            });
          }
        }
        dispatch(setMemberList(MemberList));
      }
    } catch (error) {
      console.log(error);
      setIsSummaryApiSettled(true);
    }
  };

  useEffect(() => {
    setLoader(true);
    getDefaultTab();
    if (selectedMember.mType === 'Employee') {
      console.log('in useffect here');
      fetchEmployeeData();
    } else if (
      selectedMember.mType === 'Dependent' &&
      memberDetails?.Member?.DependentsInfo.filter(
        (item) => selectedMember.ID === item.OID,
      ).length
    ) {
      fetchEmployeeData();
    }
    console.log('isApprovalFlow', isApprovalFlow);
    if (isApprovalFlow) {
      if (selectedMember?.ID) getMemberDetails();
    } else {
      fetchHippaPatientRights();
    }
  }, [selectedMember]);

  return {
    loader,
    defaultTab,
    viewUserProfile,
    viewDependent,
    viewHippaRights,
    selectedMember,
    employeeInfo: getViewEmployeeDetails(
      employeeData,
      selectedMember.mType === 'Employee' ? false : true,
    ),
    employmentDetails: getViewEmploymentDetails(employeeData),
    PhoneEmailInfo: getViewContactInformation(
      employeeData,
      selectedMember.mType === 'Employee' ? false : true,
    ),
    residentialAddress: residentialData,
    mailingAddress: mailingData,
    dependentsData,
    fetchDependentsData,
    allowEmpViewMyInfo,
    allowRespPartyViewMyInfo,
    responsiblePartyInfo,
    serverError,
    serverErrorHipaa,
    activeDependentId,
    fetchEmployeeData,
    eobPreferences,
    setEobPreferences,
  };
};

export default useProfile;
